import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import MedicationPage from './pages/MedicationPage';
import ExercisePage from './pages/ExercisePage';
import ChatPage from './pages/ChatPage';
import MealPage from './pages/MealPage';
import HomePage from './pages/HomePage';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import { theme } from './styles/theme';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<Navigate to="/start" replace />} />
                <Route path="/start" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/medication"
                  element={
                    <ProtectedRoute>
                      <MedicationPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/medication/history"
                  element={
                    <ProtectedRoute>
                      <MedicationPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/exercise"
                  element={
                    <ProtectedRoute>
                      <ExercisePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/chat"
                  element={
                    <ProtectedRoute>
                      <ChatPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/diet"
                  element={
                    <ProtectedRoute>
                      <MealPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/start" replace />} />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
